// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__19TIS","container":"styles_container__I8t2S","title":"styles_title__1GjbE","wrapper":"styles_wrapper__2GFcY","answer":"styles_answer__53i7I"};